// data from https://gamepress.gg/pokemongo/power-up-costs
export default [
  [1, 200, 1],
  [1.5, 200, 1],
  [2, 200, 1],
  [2.5, 200, 1],
  [3, 400, 1],
  [3.5, 400, 1],
  [4, 400, 1],
  [4.5, 400, 1],
  [5, 600, 1],
  [5.5, 600, 1],
  [6, 600, 1],
  [6.5, 600, 1],
  [7, 800, 1],
  [7.5, 800, 1],
  [8, 800, 1],
  [8.5, 800, 1],
  [9, 1000, 1],
  [9.5, 1000, 1],
  [10, 1000, 1],
  [10.5, 1000, 1],
  [11, 1300, 2],
  [11.5, 1300, 2],
  [12, 1300, 2],
  [12.5, 1300, 2],
  [13, 1600, 2],
  [13.5, 1600, 2],
  [14, 1600, 2],
  [14.5, 1600, 2],
  [15, 1900, 2],
  [15.5, 1900, 2],
  [16, 1900, 2],
  [16.5, 1900, 2],
  [17, 2200, 2],
  [17.5, 2200, 2],
  [18, 2200, 2],
  [18.5, 2200, 2],
  [19, 2500, 2],
  [19.5, 2500, 2],
  [20, 2500, 2],
  [20.5, 2500, 2],
  [21, 3000, 3],
  [21.5, 3000, 3],
  [22, 3000, 3],
  [22.5, 3000, 3],
  [23, 3500, 3],
  [23.5, 3500, 3],
  [24, 3500, 3],
  [24.5, 3500, 3],
  [25, 4000, 3],
  [25.5, 4000, 3],
  [26, 4000, 4],
  [26.5, 4000, 4],
  [27, 4500, 4],
  [27.5, 4500, 4],
  [28, 4500, 4],
  [28.5, 4500, 4],
  [29, 5000, 4],
  [29.5, 5000, 4],
  [30, 5000, 4],
  [30.5, 5000, 4],
  [31, 6000, 6],
  [31.5, 6000, 6],
  [32, 6000, 6],
  [32.5, 6000, 6],
  [33, 7000, 8],
  [33.5, 7000, 8],
  [34, 7000, 8],
  [34.5, 7000, 8],
  [35, 8000, 10],
  [35.5, 8000, 10],
  [36, 8000, 10],
  [36.5, 8000, 10],
  [37, 9000, 12],
  [37.5, 9000, 12],
  [38, 9000, 12],
  [38.5, 9000, 12],
  [39, 10000, 15],
  [39.5, 10000, 15],
  [40, 10000, 0, 10],
  [40.5, 10000, 0, 10],
  [41, 11000, 0, 10],
  [41.5, 11000, 0, 10],
  [42, 11000, 0, 12],
  [42.5, 11000, 0, 12],
  [43, 12000, 0, 12],
  [43.5, 12000, 0, 12],
  [44, 12000, 0, 15],
  [44.5, 12000, 0, 15],
  [45, 13000, 0, 15],
  [45.5, 13000, 0, 15],
  [46, 13000, 0, 17],
  [46.5, 13000, 0, 17],
  [47, 14000, 0, 17],
  [47.5, 14000, 0, 17],
  [48, 14000, 0, 20],
  [48.5, 14000, 0, 20],
  [49, 15000, 0, 20],
  [49.5, 15000, 0, 20],
]
